<template>
	<div style="overflow-y: auto">
		<v-container>
			<v-row justify="center" class="mb-5">
				<!-- selector invite o create -->
				<v-col v-if="loggedIn" cols="12" lg="10" xl="8" class="pt-0">
					<create-person :editable="editable" :setFilfter="word => setFilter(word)" />
				</v-col>
			</v-row>
		</v-container>
		<!-- Search, export icons, chips filter-->
		<v-container v-if="persons.length">
			<v-row justify="center" align="center">
				<v-col cols="12" class="text-center">
					<v-btn color="primary" x-small @click="exportToPdf" class="my-2 mx-2">
						descargar lista pdf
					</v-btn>
					<v-btn color="primary" x-small @click="exportToCsv" class="my-2 mx-2">
						descargar lista csv
					</v-btn>
					<v-btn
						color="secondary"
						x-small
						@click="showAssistance = !showAssistance"
						class="my-2 mx-2"
					>
						{{
							showAssistance ? 'Ver listado de personas' : 'Ver control de asistencia'
						}}
					</v-btn>
					<v-text-field
						style="max-width: 300px;"
						class="mx-auto"
						v-model="word"
						solo
						dense
						filled
						outlined
						clearable
						hide-details
						label="Filtrar por nombre, telefono o RUT"
						append-outer-icon="mdi-magnify"
						:background-color="word && !this.$vuetify.theme.isDark ? '#ded1ff' : ''"
						@input="filter"
					>
					</v-text-field>
				</v-col>
			</v-row>
		</v-container>
		<v-container v-if="showAssistance">
			<v-row justify="center">
				<v-col cols="12" lg="18" xl="8">
					<v-card flat rounded>
						<v-card-text class="px-0 px-sm-4">
							<v-skeleton-loader
								:loading="loading"
								height="94"
								type="list-item-two-line"
							>
								<assistance
									:persons="personsListFilter"
									:setPersonsId="setPersonsId"
								/>
							</v-skeleton-loader>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
		<v-container v-else>
			<v-row justify="center">
				<v-col cols="12" lg="10" xl="8">
					<v-skeleton-loader :loading="loading" height="94" type="list-item-two-line">
						<div class="ml-auto">
							<v-checkbox
								v-model="editable"
								label="Las personas invitadas pueden editar sus datos"
								color="accent"
								@click="setEditable(editable ? 'editable' : '')"
								hide-details
							/>
						</div>
						<person-list
							title="Lista de personas"
							msjnodata="No hay personas para mostrar"
							:chipsList="chipsList"
							:onChangeChips="onChangeChips"
							:persons="personsListFilter"
							:personsCreate="personsCreate"
							:personsInvite="personsInvite"
							:personsShared="personsShared"
							:warningMessage="warningMessage"
						/>
					</v-skeleton-loader>
				</v-col>
				<v-col cols="12" lg="10" xl="8">
					<v-autocomplete
						autocomplete="off"
						class="ma-2"
						v-model="form.persons"
						:search-input.sync="searchPerson"
						:items="itemsAutocompletePersons"
						:filter="personFilter"
						label="Seleccione las personas"
						:multiple="!editMode"
						outlined
						dense
						solo
						filled
						persistent-hint
						hide-details
						@change="hasChangePerson"
						append-icon="mdi-card-account-details"
					>
						<template v-slot:selection="data">
							<v-chip
								small
								:key="JSON.stringify(data.item.value)"
								v-bind="data.attrs"
								:input-value="data.selected"
								:disabled="data.disabled"
							>
								<span class="caption">{{ data.item.text }}</span>
							</v-chip>
						</template>
					</v-autocomplete>
					<!-- <input class="my-4" id="" type="file" accept="" /> -->
					<v-text-field
						class="ma-2"
						v-model="filename"
						dense
						filled
						solo
						outlined
						label="Nombre del documento"
						hint="*optional"
						persistent-hint
						autocomplete="off"
					>
						<template v-slot:append v-if="filename">
							<v-slide-x-reverse-transition mode="out-in">
								<v-icon color="success">
									mdi-check-outline
								</v-icon>
							</v-slide-x-reverse-transition>
						</template>
					</v-text-field>
					<v-file-input
						solo
						dense
						filled
						outlined
						v-model="files"
						chips
						hint="*requerido"
						multiple
						label="Agrege sus documentos"
						accept="application/pdf"
					></v-file-input>
					<v-btn
						color="blue-grey"
						class="ma-2 white--text"
						@click="onSubmitPublications"
						:disabled="disabled"
					>
						Subir documentos
						<v-icon right dark>
							mdi-cloud-upload
						</v-icon>
					</v-btn>
					<list-publications />
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import filterDocumentMixin from '@/mixins/filterDocument.js';
import moment from 'moment';
import Pusher from 'pusher-js';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { isArray } from 'lodash';

export default {
	name: 'Persons',
	components: {
		PersonList: () => import('@/components/persons/PersonList.vue'),
		CreatePerson: () => import('@/components/persons/CreatePerson'),
		Assistance: () => import('@/components/persons/Assistance'),
		ListPublications: () => import('@/components/persons/ListPublications'),
	},
	mixins: [filterDocumentMixin],
	data() {
		return {
			showAssistance: false,
			word: '',
			editable: null,
			warningMessage: '',
			toggleInvite: false,
			toggleShared: false,
			personsListFilter: [],
			pusher: null,
			channel: null,
			personsId: [],
			form: {
				persons: [],
			},
			searchPerson: '',
			filename: '',
			files: [],
			enablePublicationButton: true,
		};
	},
	computed: {
		chipsList() {
			return this.getLabelsPersons(this.persons);
		},
		personsInvite() {
			return this.personsListFilter.filter(
				person => person.isUser && person.idCompany === this.userProfile._id
			);
		},
		personsShared() {
			const authId = this.userProfile._id;
			return this.personsListFilter.filter(person => {
				const ownerId = person.ownerId ? person.ownerId : '';
				const sharedUsers = person.sharedUsers;
				return ownerId !== authId && sharedUsers.some(s => s === authId);
			});
		},
		personsCreate() {
			return this.personsListFilter.filter(person => {
				const ownerId = person.ownerId ? person.ownerId : '';
				return !person.isUser && ownerId === this.userProfile._id;
			});
		},
		itemsAutocompletePersons() {
			if (this.listPerson && this.listPerson.length)
				return this.listPerson.map(item => ({
					value: item._id,
					text: ` ${item.firstName.toUpperCase()} ${
						item.lastName ? item.lastName.toUpperCase() : ''
					} ${item.rut ? '[' + item.rut + ']' : ''}`,
				}));
			return [];
		},
		disabled() {
			if (
				this.form.persons.length != 0 &&
				this.filename != '' &&
				this.files.length != 0 &&
				this.enablePublicationButton
			)
				return false;
			return true;
		},
		...mapGetters({
			listPerson: 'Person/persons',
			persons: 'Person/persons',
			loading: 'User/globalLoading',
			editMode: 'Lodging/editMode',
		}),
	},
	created() {
		this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
			cluster: process.env.VUE_APP_PUSHER_CLUSTER,
		});
		this.pusher.connection.bind('update', function(err) {
			console.error(err);
		});
		this.channel = this.pusher.subscribe('person');
		this.channel.bind('update', data => this.$emit('updatePerson', data));
		this.$on('updatePerson', async data => {
			if (this.userProfile._id === data.idCompany) {
				const person = await this.getPerson(data.idPerson);
				this.setPersons(person);
			}
		});
	},
	mounted() {
		this.getPersons();
	},
	methods: {
		hasChangePerson() {
			this.form.setHistories = false;
			this.worked = [];
		},
		async getPersons() {
			this.personsListFilter = this.persons;
			this.setPersonsId(this.personsListFilter.map(person => person._id));
			this.editable = this.personsInvite.some(person => person.editable);
		},
		filter(word) {
			if (!word) word = '';
			if (isArray(word)) {
				// filter person by documents
				const labelDefaultSelected = this.labelDefaultSelected(word);
				this.personsListFilter = this.persons.filter(person => {
					return person.typeDocument.some(typeDocument => {
						if (typeDocument) {
							const status =
								word.includes(typeDocument.done ? 'subido' : 'pendiente') ||
								word.includes(this.itsDue(typeDocument.date) && 'caducado');
							const type = word.some(
								item => typeDocument.type.toLowerCase().indexOf(item) > -1
							);
							if (labelDefaultSelected) return status && type;
							return type;
						}
					});
				});
			} else {
				// filter person by search box
				this.personsListFilter = this.persons.filter(
					item =>
						item.firstName.toLowerCase().indexOf(word.toLowerCase()) > -1 ||
						(item.lastName &&
							item.lastName.toLowerCase().indexOf(word.toLowerCase()) > -1) ||
						(item.rut && item.rut.indexOf(word.toLowerCase()) > -1) ||
						(item.phone && item.phone.indexOf(word.toLowerCase()) > -1)
				);
			}
			this.setPersonsId(this.personsListFilter.map(person => person._id));
		},
		setFilter(word) {
			this.word = word;
			this.filter(word);
		},
		onChangeChips(labels) {
			// clear warning message
			this.warningMessage = '';
			// return to the original state persons
			if (!labels.length) return (this.personsListFilter = this.persons);
			// set warning message if empty document selected
			if (!this.labelSelected(labels))
				return (this.warningMessage = 'Por favor seleccione un documento');
			this.filter(labels);
		},
		itsDue(date) {
			return moment(date).isBefore(moment().format());
		},
		async exportToPdf() {
			try {
				const finalData = Array.from(this.personsId);
				const pdf = await this.generatePdfReport(finalData);
				let blob = new Blob([pdf], { type: 'application/pdf' });
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = 'personas.pdf';
				link.click();
			} catch (error) {
				this.snackbar({
					content: error.message,
					color: 'error',
				});
			}
		},
		async exportToCsv() {
			try {
				const csv = await this.generateCsvReport(this.userProfile._id);
				let blob = new Blob([csv], { type: 'text/csv' });
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = 'personas.csv';
				link.click();
			} catch (error) {
				this.snackbar({
					content: error.message,
					color: 'error',
				});
			}
		},
		async onSubmitPublications() {
			this.enablePublicationButton = false;
			const payload = new FormData();
			payload.append('filename', this.filename);
			this.form.persons.forEach(person => {
				payload.append('persons[]', person);
			});
			this.files.forEach(file => {
				payload.append('publications', file);
			});
			await this.uploadPublications(payload);
			this.filename = '';
			this.form.persons = [];
			this.files = [];
			this.enablePublicationButton = true;
		},
		setPersonsId(array) {
			const unique = [...new Set(array)];
			this.personsId = unique;
		},
		personFilter(item, queryText, itemText) {
			if (queryText === undefined || itemText === undefined) {
				return false;
			}
			const buscarListaPalabras = queryText
				.trim()
				.toLowerCase()
				.split(' ');
			itemText = itemText.trim().toLowerCase();

			let contar = 0;
			buscarListaPalabras.forEach(b => {
				if (itemText.indexOf(b) > -1) {
					contar++;
				}
			});

			return buscarListaPalabras.length === contar;
		},
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
			setPersons: 'Person/setPersons',
		}),
		...mapActions({
			generateCsvReport: 'Person/generateCsvReport',
			generatePdfReport: 'Person/generatePdfReport',
			getPerson: 'Person/getPerson',
			setEditable: 'Person/setEditable',
			uploadPublications: 'Person/uploadPublications',
		}),
	},
	watch: {
		persons(newValue) {
			this.personsListFilter = newValue;
			this.editable = this.personsInvite.some(person => person.editable);
		},
		editMode(newValue) {
			if (!newValue) this.dates = [];
		},
	},
};
</script>
